// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import moment from "moment";

class TakePortfolioActionService {
  private dispatch = useDispatch();

  public async getPortfolioDetailsData(
    portfolioId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/review/${portfolioId}`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/take-action/${portfolioId}`
      );
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeAction(
    portfolioId: string | undefined,
    action: string
  ): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/${portfolioId}/review`, {
        approved: action === "approve" ? true : false,
      });
      action === "approve"
        ? toast.success("Portfolio approved successfully")
        : toast.success("Portfolio rejected successfully");
      window.location.reload();
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/take-action/${portfolioId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }

  public async ApprovePortfolio(
    portfolioId: string | undefined,
    date: any | null = null
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/${portfolioId}/review`, {
        openDate: date,
        approved: true,
      });
      toast.success("Portfolio approved successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/take-action/${portfolioId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }

  public async rejectPortfolio(
    portfolioId: string | undefined,
    value: string
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/${portfolioId}/review`, {
        approved: false,
        portfolioStatusReason: value,
      });
      toast.success("Portfolio rejected successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/take-action/${portfolioId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default TakePortfolioActionService;
